import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { defaultCommandment, TCommandment } from "types/JsonType";
import constants from "Constants";
import SidebarPage from "components/templates/SidebarPage";
import MasterSidebar from "components/navigation/MasterSidebar";
import { SetDocumentTitle } from "utils/SetDocumentTitle";
import Error from "components/templates/Error";
import Commandments from "lib/data/Commandments";
import RightArrow from "components/bootstrap_icons/RightArrow";

type TCommandmentContext = {
  commandment: TCommandment;
};

const CommandmentContext = createContext<TCommandmentContext>({
  commandment: defaultCommandment,
});

function Title() {
  const { commandment } = useContext(CommandmentContext);
  return (
    <div className="w-100 text-center my-4">
      <h3 className="">{commandment.name}</h3>
      <div className="lead fs-6 ">{commandment.subTitle}</div>
    </div>
  );
}

function CommandmentContent() {
  const { commandment } = useContext(CommandmentContext);

  const [ImportedComponent, setImportedComponent] = useState(null) as any;

  useEffect(() => {
    async function ImportComponents(filePath: string) {
      setImportedComponent(null);
      await import(`${filePath}`).then((module) => {
        const AnotherComponent = module.default;
        setImportedComponent(<AnotherComponent />);
      });

      // import all adjacent commandment components. This dramatically improves the load time of the pages.
      Object.values(Commandments).forEach((page) => {
        import(`${page.filePath}`);
      });
    }

    ImportComponents(commandment.filePath);
  }, [commandment.filePath]);

  return (
    <div>
      <Title />
      <div className="w-100 d-flex">
        <div className="mx-auto w-p">{ImportedComponent}</div>
      </div>
    </div>
  );
}

export default function CommandmentRoot() {
  const navigate = useNavigate();
  const commandmentId = useParams().commandmentId;
  if (!commandmentId) return <Error message={"404. Page not found"} />;
  const commandment = Commandments[commandmentId];
  if (!commandment) return <Error message={"404. Page not found"} />;

  const prevCommandment = Object.values(Commandments).find((c) => c.num === commandment.num - 1);
  const nextCommandment = Object.values(Commandments).find((c) => c.num === commandment.num + 1);

  SetDocumentTitle(commandment.name);
  const back = () => {
    navigate(prevCommandment?.url || "/");
  };
  const next = () => {
    navigate(nextCommandment?.url || "/");
  };

  return (
    <CommandmentContext.Provider value={{ commandment: commandment }}>
      <SidebarPage.Page>
        <SidebarPage.Sidebar>
          <MasterSidebar />
        </SidebarPage.Sidebar>
        <SidebarPage.Content>
          <div className="d-flex justify-content-center mb-5 mx- mx-md-4">
            <div className={`hz-flip mt-4 ${!prevCommandment && "invisible"}`}>
              <button className="btn" onClick={back}>
                <RightArrow w="40" h="40" />
              </button>
            </div>
            <div className="w-100" style={{ maxWidth: constants.paragraphWidth }}>
              <CommandmentContent />
            </div>

            <div className={`mt-4 ${!nextCommandment && "invisible"}`}>
              <button className="btn" onClick={next}>
                <RightArrow w="40" h="40" />
              </button>
            </div>
          </div>
        </SidebarPage.Content>
      </SidebarPage.Page>
    </CommandmentContext.Provider>
  );
}
